import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import CustomButton from "../../../ui/custom-button";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import { PulseLoader } from "react-spinners";
import {
  AddEventApi,
  AddRoomApi,
  CourseListApi,
  SemesterListApiByCourse,
  SubjectListApiBySemester,
  fetchCameragrouplistingApi,
  getEventDataById,
  getRoomDataById,
  updateEventApi,
  updateRoomApi,
} from "../../../api/api";
import { toast } from "react-toastify";

function AddRoom() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [courseList, setCourseList] = useState([]);
  const [semesterList, setSemesterList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [cameraGroups, setCameraGroups] = useState([]);

  const [inputData, setInputData] = useState({
    room_name: "",
    room_description: "",
    room_no: "",
    course_id: "",
    semester_id: "",
    subject_id: "",
    event: "",
  });

  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});

  useEffect(() => {
    fetchCourses();
    fetchCameraGroup();

    if (data) fetchdata();
  }, []);

  useEffect(() => {
    if (inputData.course_id) {
      fetchSemesters(inputData.course_id);
    } else {
      setSemesterList([]);
      setInputData((prev) => ({ ...prev, semester_id: "", subject_id: "" }));
    }
  }, [inputData.course_id]);

  useEffect(() => {
    if (inputData.semester_id) {
      fetchSubjects(inputData.semester_id);
    } else {
      setSubjectList([]);
      setInputData((prev) => ({ ...prev, subject_id: "" }));
    }
  }, [inputData.semester_id]);

  const fetchdata = async () => {
    try {
      const detail = await getRoomDataById(data);
      if (detail?.data?.status === true) {
        const fetched = detail?.data?.data;
        //console.log("fetched", fetched);
        setInputData({
          room_name: fetched?.event_name || "",
          room_description: fetched?.room_description || "",
          room_no: fetched?.room_no || "",
          course_id: fetched?.course_id || "",
          semester_id: fetched?.semester_id || "",
          subject_id: fetched?.subject_id || "",
          event: fetched?.camera_grp_id || "",
        });

        if (fetched?.course_id) {
          await fetchSemesters(fetched.course_id);
        }

        if (fetched?.semester_id) {
          await fetchSubjects(fetched.semester_id);
        }
      }
    } catch (error) {
      console.error("Fetch event data error:", error);
    }
  };

  const fetchCourses = async () => {
    try {
      const res = await CourseListApi();
      if (res?.data?.status === true) {
        setCourseList(res.data.data);
      }
    } catch (error) {
      console.error("Course fetch error:", error);
    }
  };

  const fetchSemesters = async (courseId) => {
    try {
      const res = await SemesterListApiByCourse(courseId);

      if (res?.data?.status === true) {
        setSemesterList(res?.data?.semesters || []);
      }
    } catch (error) {
      console.error("Semester fetch error:", error);
    }
  };

  const fetchSubjects = async (semesterId) => {
    try {
      const res = await SubjectListApiBySemester(semesterId);
      if (res?.data?.status === true) {
        setSubjectList(res?.data?.subjects || []);
      }
    } catch (error) {
      console.error("Subject fetch error:", error);
    }
  };

  const fetchCameraGroup = async () => {
    try {
      const data = await fetchCameragrouplistingApi();
      if (data?.data?.status === true) {
        setCameraGroups(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClose = () => {
    dispatch(SetPopupReducerData({ modalType: "", showModal: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      room_name: inputData.room_name,
      room_description: inputData.room_description,
      room_no: inputData.room_no,
      subject_id: inputData.subject_id,
      camera_grp_id: inputData.event,
    };
    //console.log("payload", payload);

    try {
      let response;
      if (data) {
        response = await updateRoomApi(payload, data);
      } else {
        response = await AddRoomApi(payload);
      }

      if (response?.data?.status) {
        toast.success(
          data ? "Room updated successfully" : "Room created successfully"
        );
        handleClose();
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Add Room</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12 mb-3">
            <label className="form-label">Room Name</label>
            <CustomInput
              name="room_name"
              placeholder="Enter Room Name"
              value={inputData.room_name}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Room Description</label>
            <CustomInput
              name="room_description"
              placeholder="Enter Room Description"
              value={inputData.room_description}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Room No</label>
            <CustomInput
              name="room_no"
              placeholder="Enter Room No"
              value={inputData.room_no}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Camera Group</label>
            <select
              name="event"
              className="form-select"
              value={inputData.event}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {cameraGroups &&
                cameraGroups?.map((ele) => (
                  <option value={ele?._id}>{ele?.camera_grp_name}</option>
                ))}
            </select>
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Course</label>
            <select
              name="course_id"
              className="form-select"
              value={inputData.course_id}
              onChange={handleChange}
            >
              <option value="">Select Course</option>
              {courseList?.map((ele) => (
                <option key={ele._id} value={ele._id}>
                  {ele.course_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Semester</label>
            <select
              name="semester_id"
              className="form-select"
              value={inputData?.semester_id}
              onChange={handleChange}
              disabled={!inputData.course_id}
            >
              <option value="">Select Semester</option>
              {semesterList?.map((ele) => (
                <option key={ele._id} value={ele._id}>
                  {ele.semester_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Subject</label>
            <select
              name="subject_id"
              className="form-select"
              value={inputData.subject_id}
              onChange={handleChange}
              disabled={!inputData.semester_id}
            >
              <option value="">Select Subject</option>
              {subjectList?.map((ele) => (
                <option key={ele._id} value={ele._id}>
                  {ele.subject_name}
                </option>
              ))}
            </select>
          </div>

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            <CustomButton type="submit" className="btnSubmit px-4 py-2">
              {loading ? <PulseLoader color="#fff" size={8} /> : "Submit"}
            </CustomButton>
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddRoom;
